/* WO757: scoped totals, persistent choices and one lifecycle per CYM block. */
(function () {
  'use strict';
  if (window.__mzCymRuntime) return;
  var states = new Map();
  var pending = new Set();
  var pageObserver;
  function moneyFormatter(currency, locale) {
    try {
      var fmt = new Intl.NumberFormat(locale || 'en', { style: 'currency', currency: currency || 'USD' });
      return function (cents) {
        return fmt.format(cents / 100);
      };
    } catch (e) {
      return function (cents) {
        return '$' + (cents / 100).toFixed(2);
      };
    }
  }

  function collectFormProperties(form) {
    var props = {};
    /*
     * WO-654 F06: form.elements, not form.querySelectorAll. Property inputs that belong to this form through the form=
     * attribute but sit outside it in the DOM (the pre-order property in snippets/product.liquid, the ones in
     * snippets/product-properties.liquid) are only found through form.elements; the old query dropped them from the
     * case line whenever a scroll was ticked. Broadcast's own add path reads new FormData(form), which includes them.
     */
    var fields = Array.prototype.slice.call(form.elements || form.querySelectorAll('[name^="properties["]')).filter(function (field) {
      return field.name && field.name.indexOf('properties[') === 0;
    });
    fields.forEach(function (field) {
      var match = field.name.match(/^properties\[(.+)\]$/);
      if (!match) return;
      var key = match[1];
      if (field.type === 'checkbox' || field.type === 'radio') {
        if (field.checked && field.value) props[key] = field.value;
      } else if (field.value) {
        props[key] = field.value;
      }
    });
    return props;
  }


  function initBlock(block) {
    if (states.has(block)) return;
    var form = document.getElementById(block.dataset.productFormId);
    if (!form) { pending.add(block); return; }
    pending.delete(block);
    var controller = new AbortController();
    var signal = controller.signal;
    var root = block.closest('product-info') || form.closest('[data-section-type], section') || form;
    var format = moneyFormatter(block.dataset.currency, block.dataset.locale);
    var summary = block.querySelector('[data-mz-cym-summary]');
    var label = summary && summary.querySelector('.mz-cym-summary__label');
    var total = summary && summary.querySelector('.mz-cym-summary__total');
    var prep = block.querySelector('[data-mz-cym-prep-input]');
    var error = block.querySelector('[data-mz-cym-error]');
    var buttons = form.closest('.product__block--buttons');
    var shipping = root.querySelector('.mz-shipping-info');
    var basePrice = parseInt(summary ? summary.dataset.basePriceCents : '0', 10) || 0;
    var initialPriceHTML = null;
    var busy = false;
    var alive = true;
    var initialising = true;
    var timer = null;
    var retryTimer = null;
    var quantityTimer = null;
    var onAdded = null;
    var availabilityObserver;
    var submit = form.querySelector('[data-add-to-cart]');

    function priceElement() {
      return form.querySelector('[data-add-to-cart] [data-product-price]');
    }
    var firstPrice = priceElement();
    if (firstPrice) initialPriceHTML = firstPrice.innerHTML;
    function toggles() {
      return Array.prototype.slice.call(block.querySelectorAll('[data-mz-cym-toggle]'));
    }
    function checkedToggles() {
      return toggles().filter(function (toggle) { return toggle.checked && !toggle.disabled; });
    }
    function quantities() {
      var field = form.elements && form.elements.namedItem ? form.elements.namedItem('quantity') : form.querySelector('[name="quantity"]');
      var quantity = field ? parseInt(field.value, 10) : 1;
      if (!(quantity >= 1)) quantity = 1;
      return { caseQty: quantity, addonQty: block.dataset.mzCymQtyFollows === 'false' ? 1 : quantity };
    }
    function updateSummary() {
      if (!alive) return;
      var checked = checkedToggles();
      var extra = checked.reduce(function (sum, toggle) { return sum + (parseInt(toggle.dataset.priceCents, 10) || 0); }, 0);
      var qty = quantities();
      var cents = basePrice * qty.caseQty + extra * qty.addonQty;
      var count = checked.length;
      if (summary && label && total) {
        var prefix = summary.dataset.labelPrefix || 'Your mezuzah';
        var line = count === 0 ? summary.dataset.labelCaseOnly || 'Case only' :
          (summary.dataset.labelWithScrolls || 'Case + {count} scroll(s)').replace('{count}', count).replace('scroll(s)', count === 1 ? 'scroll' : 'scrolls');
        label.textContent = prefix + ': ' + line;
        total.textContent = format(cents);
      }
      var price = priceElement();
      if (price) price.innerHTML = count === 0 && initialPriceHTML !== null ? initialPriceHTML : format(cents);
      block.dispatchEvent(new CustomEvent('mz:cym:total', { bubbles: true, detail: { cents: cents, count: count, quantity: qty.caseQty, formId: form.id } }));
    }
    function setSoldOut(soldOut) {
      block.classList.toggle('mz-cym--soldout', soldOut);
      if (buttons) buttons.classList.toggle('mz-soldout-active', soldOut);
      if (shipping) shipping.classList.toggle('mz-shipping-info--soldout', soldOut);
      toggles().forEach(function (toggle) { toggle.disabled = soldOut; });
      Array.prototype.forEach.call(block.querySelectorAll('.mz-cym__expander'), function (details) {
        if (soldOut) {
          if (!details.hasAttribute('data-mz-prev-open')) details.setAttribute('data-mz-prev-open', details.open && !initialising ? '1' : '0');
          details.open = true;
        } else if (details.hasAttribute('data-mz-prev-open')) {
          details.open = details.getAttribute('data-mz-prev-open') === '1';
          details.removeAttribute('data-mz-prev-open');
        }
      });
      updateSummary();
    }
    function checkAvailability() {
      if (!alive) return;
      var button = form.querySelector('[data-add-to-cart]');
      if (!button) return;
      if (button.hasAttribute('data-mz-variant-available')) {
        setSoldOut(button.dataset.mzVariantAvailable !== 'true');
      } else {
        var selected = root.querySelector('variant-selects [data-selected-variant]');
        if (selected) {
          try { setSoldOut(!JSON.parse(selected.textContent).available); } catch (err) {}
        }
      }
    }
    function onPrice(event) {
      if (event.target !== root || !event.detail || !event.detail.variant) return;
      basePrice = Number(event.detail.basePrice) || 0;
      initialPriceHTML = event.detail.priceHTML;
      checkAvailability();
    }
    function showError(show) { if (error && alive) error.classList.toggle('is-visible', !!show); }
    var technical = /failed to fetch|failed to execute|unexpected end of json|networkerror|load failed|typeerror|: undefined\s*$|^cart error:?\s*$|^error:?\s*$/i;
    function tidyThemeErrors() {
      var drawer = document.querySelector('[data-cart-errors], .cart__errors');
      var friendly = !!(drawer && drawer.textContent.trim());
      Array.prototype.forEach.call(root.querySelectorAll('[data-cart-errors-container]'), function (box) {
        var text = box.textContent.trim();
        if (!text) return;
        if (technical.test(text)) { box.textContent = ''; box.classList.remove('is-visible'); }
        else friendly = true;
      });
      return friendly;
    }
    function clearWatch() {
      if (timer !== null) clearInterval(timer);
      if (retryTimer !== null) clearTimeout(retryTimer);
      timer = retryTimer = null;
      if (onAdded && submit) submit.removeEventListener('theme:product:add', onAdded);
      onAdded = null;
    }
    function onSubmit(event) {
      if (event.target !== form || block.classList.contains('mz-cym--soldout')) return;
      var checked = checkedToggles();
      if (!checked.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy || (submit && submit.disabled)) return;
      var id = form.querySelector('[name="id"]');
      if (!id || !id.value || !form.checkValidity()) return;
      var qty = quantities();
      var items = [{ id: id.value, quantity: qty.caseQty, properties: collectFormProperties(form) }];
      checked.forEach(function (toggle) {
        items.push({ id: toggle.dataset.variantId, quantity: qty.addonQty, properties: { 'Scroll Preparation': prep ? prep.value : '' } });
      });
      busy = true;
      showError(false);
      var cart = document.querySelector('cart-items');
      if (cart && typeof cart.addToCart === 'function') {
        var succeeded = false;
        onAdded = function () { succeeded = true; busy = false; clearWatch(); };
        if (submit) submit.addEventListener('theme:product:add', onAdded);
        try { cart.addToCart(items, submit); }
        catch (err) { busy = false; clearWatch(); showError(true); return; }
        if (succeeded) return;
        var start = Date.now();
        timer = setInterval(function () {
          if (!alive || succeeded) { clearWatch(); return; }
          var elapsed = Date.now() - start;
          var friendly = tidyThemeErrors();
          if (submit && !submit.disabled && elapsed > 1500) {
            busy = false;
            if (!friendly) showError(true);
            if (timer !== null) clearInterval(timer);
            timer = null;
            retryTimer = setTimeout(function () {
              if (alive && !succeeded && !tidyThemeErrors()) showError(true);
              clearWatch();
            }, 800);
          } else if (elapsed > 20000) { busy = false; clearWatch(); }
        }, 250);
        return;
      }
      var url = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';
      if (submit) submit.disabled = true;
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (response) { if (!response.ok) throw new Error('cart add failed'); if (alive) window.location.href = window.location.pathname + window.location.search; })
        .catch(function () { if (alive) { busy = false; if (submit) submit.disabled = false; showError(true); } });
    }
    function onQuantity(event) {
      if (event.target && event.target.matches && event.target.matches('[name="quantity"]')) {
        var selected = root.querySelector('variant-selects [data-selected-variant]');
        var variant = null;
        if (selected) {
          try { variant = JSON.parse(selected.textContent); basePrice = Number(variant.price) || 0; } catch (err) {}
        }
        var qty = quantities();
        initialPriceHTML = basePrice === 0 && window.theme && window.theme.strings ? window.theme.strings.free : format(basePrice * qty.caseQty);
        if (variant && Number(variant.compare_at_price) > basePrice) initialPriceHTML += ' <s>' + format(Number(variant.compare_at_price) * qty.caseQty) + '</s>';
        updateSummary();
      }
    }
    form.addEventListener('input', onQuantity, { signal: signal });
    form.addEventListener('change', onQuantity, { signal: signal });
    form.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('[data-quantity-selector], .quantity, [data-quantity-minus], [data-quantity-plus]')) {
        if (quantityTimer !== null) clearTimeout(quantityTimer);
        quantityTimer = setTimeout(function () { var field = form.querySelector('[name="quantity"]'); if (field && alive) onQuantity({ target: field }); }, 0);
      }
    }, { signal: signal });
    block.addEventListener('change', function (event) { if (event.target.matches('[data-mz-cym-toggle]')) updateSummary(); }, { signal: signal });
    root.addEventListener('mz:product:price', onPrice, { signal: signal });
    root.addEventListener('theme:product-info:loaded', checkAvailability, { signal: signal });
    document.addEventListener('submit', onSubmit, { capture: true, signal: signal });
    block.addEventListener('click', function (event) {
      if (!block.classList.contains('mz-cym--soldout') || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.target.closest('.mz-cym-row__title')) return;
      var row = event.target.closest('.mz-cym-row__label');
      var link = row && row.querySelector('.mz-cym-row__title');
      if (link) { event.preventDefault(); window.location.href = link.href; }
    }, { signal: signal });
    if (submit && window.MutationObserver) {
      availabilityObserver = new MutationObserver(checkAvailability);
      availabilityObserver.observe(submit, { attributes: true, attributeFilter: ['data-mz-variant-available'] });
    }
    var state = { destroy: function () { alive = false; controller.abort(); clearWatch(); if (quantityTimer !== null) clearTimeout(quantityTimer); if (availabilityObserver) availabilityObserver.disconnect(); } };
    states.set(block, state);
    setSoldOut(block.classList.contains('mz-cym--soldout'));
    checkAvailability();
    initialising = false;
  }
  function scan() {
    states.forEach(function (state, block) {
      if (!block.isConnected) { state.destroy(); states.delete(block); }
    });
    pending.forEach(function (block) { if (!block.isConnected) pending.delete(block); });
    document.querySelectorAll('[data-mz-cym]').forEach(initBlock);
  }
  window.__mzCymRuntime = { scan: scan };
  function start() {
    scan();
    if (window.MutationObserver) {
      // WO-790: scan only for a CYM block, its pending form, or removal of a tracked block.
      pageObserver = new MutationObserver(function (records) {
        var touched = false;
        for (var i = 0; i < records.length && !touched; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length && !touched; j++) {
            var n = added[j];
            if (n.nodeType === 1 && (n.hasAttribute('data-mz-cym') || n.querySelector('[data-mz-cym]'))) touched = true;
            if (!touched && n.nodeType === 1) pending.forEach(function (block) {
              var form = document.getElementById(block.dataset.productFormId);
              if (form && (n === form || n.contains(form))) touched = true;
            });
          }
          if (!touched && records[i].removedNodes.length) {
            states.forEach(function (state, block) { if (!block.isConnected) touched = true; });
            pending.forEach(function (block) { if (!block.isConnected) touched = true; });
          }
        }
        if (touched) scan();
      });
      pageObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', scan);
    document.addEventListener('shopify:section:unload', scan);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
